import * as React from 'react';
import { observer } from 'mobx-react';
import { getExtendedTheme } from 'owa-fabric-theme';
import { classNamesFunction } from '@uifabric/utilities';

import { getStyles } from './CommonFloatingPickerItem.styles';
import {
    CommonFloatingPickerItemStyleProps,
    CommonFloatingPickerItemStyles,
    CommonFloatingPickerItemProps,
} from './CommonFloatingPickerItem.types';

const getClassNames = classNamesFunction<
    CommonFloatingPickerItemStyleProps,
    CommonFloatingPickerItemStyles
>();

@observer
export default class CommonFloatingPickerItem extends React.Component<
    CommonFloatingPickerItemProps,
    any
> {
    private addSelectedItem = (evt: React.MouseEvent<any>) => {
        evt.preventDefault();
        if (this.props.addPickerItemAction) {
            this.props.addPickerItemAction(this.props.pickerItemData);
        }
    };

    render() {
        let {
            isHighlighted,
            personaControl,
            firstLineElement,
            secondLineElement,
            theme = getExtendedTheme(),
            overrides,
        } = this.props;
        const classNames = getClassNames(getStyles, {
            theme: theme,
            isHighlighted: isHighlighted,
            overrides: overrides,
        });

        return (
            <div className={classNames.container} onClick={this.addSelectedItem}>
                <div className={classNames.personaContainer}>
                    <div className={classNames.personaImage}>{personaControl}</div>
                    <div className={classNames.personaText}>
                        {firstLineElement}
                        {secondLineElement}
                    </div>
                </div>
            </div>
        );
    }
}
